const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}
// ===============================
// ===============================
// Product card color swatches
// ===============================

function getCardFromSwatch(swatch) {
  return (
    swatch.closest('.card-wrapper') ||
    swatch.closest('.product-card-wrapper') ||
    swatch.closest('.card')
  );
}

function updateCardImage(swatch) {
  const card = getCardFromSwatch(swatch);
  if (!card) return;

  const img = card.querySelector('img');
  const newImage = swatch.getAttribute('data-image');
  if (!img || !newImage) return;

  if (!img.dataset.originalSrc) {
    img.dataset.originalSrc = img.currentSrc || img.src;
  }

  img.src = newImage;
  img.srcset = newImage;
}

function resetCardImageFromSwatches(swatchesWrap) {
  const card =
    swatchesWrap.closest('.card-wrapper') ||
    swatchesWrap.closest('.product-card-wrapper') ||
    swatchesWrap.closest('.card');

  if (!card) return;

  const img = card.querySelector('img');
  if (!img || !img.dataset.originalSrc) return;

  img.src = img.dataset.originalSrc;
  img.srcset = img.dataset.originalSrc;
}

// ---- HOVER (Desktop only)
document.addEventListener('mouseover', function (e) {
  if (window.matchMedia('(hover: none)').matches) return;

  const swatch = e.target.closest('.color-swatch');
  if (!swatch) return;

  updateCardImage(swatch);
});

document.addEventListener('mouseout', function (e) {
  if (window.matchMedia('(hover: none)').matches) return;

  const wrap = e.target.closest('.color-swatches');
  if (!wrap) return;

  if (e.relatedTarget && wrap.contains(e.relatedTarget)) return;

  resetCardImageFromSwatches(wrap);
});

// ---- CLICK (Mobile + Desktop)
document.addEventListener('click', function (e) {
  const swatch = e.target.closest('.color-swatch');
  if (!swatch) return;

  e.preventDefault();
  e.stopPropagation();
  if (e.stopImmediatePropagation) e.stopImmediatePropagation();

  updateCardImage(swatch);
});

document.addEventListener("DOMContentLoaded", () => {
  const bar = document.querySelector(".footer__localization");
  if (!bar) return;

  const closeBtn = bar.querySelector(".localization-close");

  // Debug (kannst du später löschen)
  console.log("Localization loaded", { bar, closeBtn });

  // Bereits geschlossen?
  if (localStorage.getItem("hideLocalization") === "true") {
    bar.classList.add("hidden");
    return;
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", () => {
      bar.classList.add("hidden");
      localStorage.setItem("hideLocalization", "true");
    });
  }
});

// Force valid variant when changing color (works even if current size is sold out)
(() => {
  let variantsCache = null;
  let loading = false;

  function getHandleFromUrl() {
    const parts = window.location.pathname.split('/').filter(Boolean);
    const idx = parts.indexOf('products');
    return idx >= 0 ? parts[idx + 1] : null;
  }

  async function loadVariants() {
    if (variantsCache || loading) return variantsCache;
    loading = true;

    const handle = getHandleFromUrl();
    if (!handle) return null;

    try {
      const res = await fetch(`/products/${handle}.js`);
      const data = await res.json();
      variantsCache = data.variants || [];
      return variantsCache;
    } catch (e) {
      console.warn('Could not load product variants', e);
      return null;
    } finally {
      loading = false;
    }
  }

  function getPicker(el) {
    return el.closest('variant-radios, variant-selects, form');
  }

  function readSelectedOptions(picker) {
    const selected = [];

    // Dawn-like radios in fieldsets (Option1, Option2, ...)
    const fieldsets = picker.querySelectorAll('fieldset');
    if (fieldsets.length) {
      fieldsets.forEach(fs => {
        const checked = fs.querySelector('input[type="radio"]:checked');
        selected.push(checked ? checked.value : null);
      });
      return selected;
    }

    // Select dropdown fallback
    picker.querySelectorAll('select').forEach(sel => selected.push(sel.value));
    return selected;
  }

  function pickOption2(picker, value) {
    // Try radios
    const fieldsets = picker.querySelectorAll('fieldset');
    if (fieldsets.length >= 2) {
      const fs2 = fieldsets[1];
      const input = fs2.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
      if (input && !input.disabled) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return true;
      }
    }

    // Try selects
    const selects = picker.querySelectorAll('select');
    if (selects.length >= 2) {
      const sel2 = selects[1];
      sel2.value = value;
      sel2.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    return false;
  }

  document.addEventListener('change', async (e) => {
    const picker = getPicker(e.target);
    if (!picker) return;

    // Nur reagieren, wenn Option1 (Farbe) geändert wurde:
    // In Dawn ist das meistens Fieldset 1. Wir prüfen: Event kommt aus dem ersten Fieldset oder ersten Select.
    const isColorChange =
      (e.target.closest('fieldset') && Array.from(picker.querySelectorAll('fieldset')).indexOf(e.target.closest('fieldset')) === 0) ||
      (e.target.tagName === 'SELECT' && Array.from(picker.querySelectorAll('select')).indexOf(e.target) === 0);

    if (!isColorChange) return;

    const variants = await loadVariants();
    if (!variants || !variants.length) return;

    const selected = readSelectedOptions(picker);
    const color = selected[0];
    const size = selected[1];

    if (!color) return;

    // Prüfen, ob die aktuelle Kombi existiert und verfügbar ist
    const exact = variants.find(v => v.option1 === color && v.option2 === size);
    if (exact && exact.available) return;

    // Sonst: erste verfügbare Größe für diese Farbe nehmen
    const fallback = variants.find(v => v.available && v.option1 === color);
    if (!fallback) return;

    // Wähle Option2 (Größe) auf verfügbare um
    pickOption2(picker, fallback.option2);
  });
})();